'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print catalogue price
 */
    .directive('capCatalogueProductPrice', function () {
        return {
            restrict: 'A',
            scope: {
                promotionProcessing: "=",
                overrideTextRegular: "=",
                overrideTextPromotion: "=",
                price: "="
            },
            templateUrl: "templates/catalogueproductprice.html"
        }
    });